import React from "react";
import { useLayoutEffect } from "react";

import { useGlobalContext } from "../Context";

function Events() {
  const { setNav } = useGlobalContext();
  useLayoutEffect(() => {
    setNav(false);
    document.title = "Beyond Limits Football Academy - Events";
  }, [setNav]);
  return (
    <main className="container py-5">
      <div className="Events__header--background">
        <div className="Events__header">
          <p className="Events__title">date</p>
        </div>
        <div className="Events__header">
          <p className="Events__title">date</p>
        </div>
        <div className="Events__header">
          <p className="Events__title">date</p>
        </div>
        <div className="Events__header">
          <p className="Events__title">date</p>
        </div>
      </div>
      <article className="Events__grid__item">
        <div className="Events__Info">
          <div className="Events__header--data">
          <p className="Events__Data">hello</p>
          </div>
          <div className="Events__header--data">
          <p className="Events__title ">hello</p>
          </div>
          <div className="Events__header--data">
          <p className="Events__Data">hello</p>
          </div>
          <div className="Events__header--data">
          <p className="Events__Data">hello</p>
          </div>
        </div>
        <div className="Events__button">
          <a href="#" className="Events__button--link">
            read more
          </a>
        </div>
      </article>
      <article className="Events__grid__item">
        <div className="Events__Info">
          <div className="Events__header--data">
          <p className="Events__Data">hello</p>
          </div>
          <div className="Events__header--data">
          <p className="Events__title ">hello</p>
          </div>
          <div className="Events__header--data">
          <p className="Events__Data">hello</p>
          </div>
          <div className="Events__header--data">
          <p className="Events__Data">hello</p>
          </div>
        </div>
        <div className="Events__button">
          <a href="#" className="Events__button--link">
            read more
          </a>
        </div>
      </article>
      <article className="Events__grid__item">
        <div className="Events__Info">
          <div className="Events__header--data">
          <p className="Events__Data">hello</p>
          </div>
          <div className="Events__header--data">
          <p className="Events__title ">hello</p>
          </div>
          <div className="Events__header--data">
          <p className="Events__Data">hello</p>
          </div>
          <div className="Events__header--data">
          <p className="Events__Data">hello</p>
          </div>
        </div>
        <div className="Events__button">
          <a href="#" className="Events__button--link">
            read more
          </a>
        </div>
      </article>
    </main>
  );
}

export default Events;
